var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from '@web/components/ui/Form/Select';
import { IS_DEMO } from '@web/config';
import { useUserContext } from '@web/contexts/User';
import { useWorkspaceCtx } from '@web/contexts/Workspace';
import { NavigateTo } from '@web/router/NavigateTo';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useHasScope } from '@web/utility/hooks/useHasScope';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { CanAccess } from '@web/utility/wrapper/CanAccess';
import { ScopeUIFilterEnum } from '@workalizer/shared';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
export function MeetingSearchTeamFilter(_a) {
    var _b, _c;
    var _d = _a.isDisplayLabel, isDisplayLabel = _d === void 0 ? true : _d;
    var _e = useWorkspaceCtx(), orgUnits = _e.orgUnits, users = _e.users;
    var currentUser = useUserContext().currentUser;
    var filters = useFilters();
    var navigateTo = useNavigateTo();
    var location = useLocation();
    var t = useTranslation().t;
    var hasScopeOrgUnitFilter = useHasScope(ScopeUIFilterEnum.FILTER_ORG_UNIT);
    var teamOptions = __spreadArray([
        {
            id: null,
            name: IS_DEMO ? t('filters.any') : t('filters.all'),
            isAll: true
        }
    ], orgUnits.map(function (orgUnit) { return ({
        id: orgUnit.id,
        name: orgUnit.title,
        disabled: !users.some(function (user) { var _a; return ((_a = user.orgUnit) === null || _a === void 0 ? void 0 : _a.id) === orgUnit.id; })
    }); }), true);
    var selectedTeam = (_b = teamOptions.find(function (team) { return team.id === filters.orgUnit; })) !== null && _b !== void 0 ? _b : teamOptions[0];
    function onChange(newOption) {
        var orgUnitId = newOption.id;
        var selectedUserStillInTeam = !filters.user ||
            users.some(function (user) {
                var _a;
                return user.id === filters.user &&
                    (!orgUnitId || ((_a = user.orgUnit) === null || _a === void 0 ? void 0 : _a.id) === orgUnitId);
            });
        navigateTo({
            pathname: location.pathname,
            newFilters: {
                orgUnit: orgUnitId,
                user: selectedUserStillInTeam ? filters.user : null
            }
        });
    }
    if (!hasScopeOrgUnitFilter && ((_c = currentUser === null || currentUser === void 0 ? void 0 : currentUser.orgUnit) === null || _c === void 0 ? void 0 : _c.id) !== filters.orgUnit) {
        var currentOrgUnitOption = teamOptions.find(function (team) { var _a; return team.id === ((_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.orgUnit) === null || _a === void 0 ? void 0 : _a.id); });
        if (currentOrgUnitOption) {
            return (_jsx(NavigateTo, { pathname: location.pathname, newFilters: { orgUnit: currentOrgUnitOption.id } }));
        }
        return null;
    }
    return (_jsx(CanAccess, __assign({ scope: ScopeUIFilterEnum.FILTER_ORG_UNIT }, { children: _jsx(Select, { isDisplayLabel: isDisplayLabel, label: t('app.apps.searchMeetings.filters.team'), selected: selectedTeam, options: teamOptions, onChange: onChange, placeholder: t('filters.any'), withSearchField: true }) })));
}
export function MeetingSearchUserFilter(_a) {
    var _b, _c;
    var _d = _a.isDisplayLabel, isDisplayLabel = _d === void 0 ? true : _d;
    var users = useWorkspaceCtx().users;
    var currentUser = useUserContext().currentUser;
    var filters = useFilters();
    var navigateTo = useNavigateTo();
    var location = useLocation();
    var t = useTranslation().t;
    var hasScopeUserFilter = useHasScope(ScopeUIFilterEnum.FILTER_USER);
    var usersInTeam = filters.orgUnit
        ? users.filter(function (user) { var _a; return ((_a = user.orgUnit) === null || _a === void 0 ? void 0 : _a.id) === filters.orgUnit; })
        : users;
    var userOptions = __spreadArray([
        {
            id: null,
            name: t('filters.any'),
            isAll: true
        }
    ], usersInTeam.map(function (user) { return ({
        id: user.id,
        name: user.name || user.email,
        avatar: user.avatar
    }); }), true);
    var selectedUser = (_b = userOptions.find(function (user) { return user.id === filters.user; })) !== null && _b !== void 0 ? _b : null;
    function onChange(newOption) {
        navigateTo({
            pathname: location.pathname,
            newFilters: {
                user: newOption.id
            }
        });
    }
    if (!hasScopeUserFilter && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) !== filters.user) {
        return (_jsx(NavigateTo, { pathname: location.pathname, newFilters: { user: (_c = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) !== null && _c !== void 0 ? _c : null } }));
    }
    return (_jsx(CanAccess, __assign({ scope: ScopeUIFilterEnum.FILTER_USER }, { children: _jsx(Select, { isDisplayLabel: isDisplayLabel, label: t('app.apps.searchMeetings.filters.user'), selected: selectedUser, options: userOptions, onChange: onChange, placeholder: t('filters.any'), showAvatars: true, withSearchField: true }) })));
}
